export default __webpack_public_path__ + "static/media/closet3-768w.87298f72.webp";